import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { px2rem } from '../utils/helpers/style.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var checkboxAttributesNative = {
  iconColor: 'background',
  color: 'primary',
  background: {
    unselected: 'background'
  },
  borders: {
    radius: 'borders.radius',
    unselected: 'widget.inactive',
    selected: 'primary'
  },
  label: {
    fontSize: '18px',
    disabled: 'label.disabled',
    normal: 'text'
  },
  disabled: {
    /**
     * Affects disabled and readOnly checkboxes
     */
    borderColor: 'border.disabled',
    backgroundColor: 'widget.disabled'
  },
  checkmarkOrientation: 'left'
};
var checkboxThemeNative = _objectSpread(_objectSpread({}, checkboxAttributesNative), {}, {
  variants: {
    condensed: {
      label: {
        fontSize: '16px'
      }
    }
  }
});
var checkboxAttributesWeb = {
  color: 'primary',
  background: 'background',
  borders: {
    radius: 'borders.radius',
    color: 'widget.inactive'
  },
  label: {
    /**
     * Disabled color
     */
    disabled: 'label.disabled',
    /**
     * Normal color
     */
    normal: 'text',
    fontSize: px2rem(18),
    lineHeight: px2rem(24)
  },
  disabled: {
    /**
     * Affects disabled and readOnly checkboxes
     */
    borderColor: 'border.disabled',
    backgroundColor: 'widget.disabled'
  }
};
var checkboxThemeWeb = _objectSpread(_objectSpread({}, checkboxAttributesWeb), {}, {
  variants: {
    condensed: {
      label: {
        fontSize: px2rem(16)
      }
    }
  }
});

export { checkboxThemeNative, checkboxThemeWeb };
